import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconCloseLarge } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
/**
 * Custom header of the {@code ChatDialog}.
 *
 * @returns {React$Element<any>}
 */
function ChatHeader({ className, isPollsEnabled, onCancel, persistent, dockSide, onDockChange }) {
    const { t } = useTranslation();
    return (React.createElement("div", { className: className || 'chat-dialog-header' },
        React.createElement("span", { id: 'chat-header', "aria-level": 2, role: 'heading' }, t(isPollsEnabled ? 'chat.titleWithPolls' : 'chat.title')),
        dockSide && React.createElement(Button, { accessibilityLabel: `Dock chat on the ${dockSide === 'right' ? 'left' : 'right'}`, label: dockSide === 'right' ? 'Dock left' : 'Dock right', onClick: onDockChange, type: BUTTON_TYPES.TERTIARY }),
        !persistent && React.createElement(Button, { accessibilityLabel: t('toolbar.closeChat'), icon: IconCloseLarge, onClick: onCancel, type: BUTTON_TYPES.TERTIARY })));
}
export default ChatHeader;
